export default __webpack_public_path__ + "static/media/icon4.fe8aa3f0.svg";